import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_prod/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { splitProps as e } from "./propUtils.js";

function t(t) {
  return function (a) {
    a.hasOwnProperty("_delegatedEventNames") || (a._delegatedEventNames = a._delegatedEventNames ? a._delegatedEventNames.slice() : []);
    var r = a._delegatedEventNames,
        s = Array.isArray(t) ? t : e(t);
    r.push.apply(r, _toConsumableArray(s));
  };
}

export { t as vmEvent };